
export const GET_DONORS_SUCCESS = 'GET_DONORS_SUCCESS';
export const GET_DONORS_FAILURE = 'GET_DONORS_FAILURE';

export const POST_DONORS_SUCCESS = 'POST_DONORS_SUCCESS';
export const POST_DONORS_FAILURE = 'POST_DONORS_FAILURE';
